<template>
  <div
    class="border-solid border-0 border-b border-gray-600 flex flex-row flex-wrap items-center"
    role="row"
    ref="container"
  >
    <div
      v-for="(column, index) in columns"
      :key="index"
      class="flex-1 py-4 lg:block"
      :class="{
        'block': column.onMobile,
        'hidden': !column.onMobile,
        'md:hidden': !column.onTablet,
        'md:block': column.onTablet
      }"
      role="gridcell"
    >
      <div>
        <p
          v-if="row[column.value].text"
          class="block font-light font-sans leading-snug subpixel-antialiased text-base text-black break-words"
          :class="{
            'font-semibold lg:font-light': column.value === 'givenName'
          }"
        >
          <span>
            {{ row[column.value].text }}
          </span>
        </p>
        <p
          v-else-if="row[column.value].entitlements"
          class="block font-light font-sans leading-snug subpixel-antialiased text-base text-black"
        >{{ formattedUserRole }}</p>
        <p
          v-else
          class="block font-light font-sans leading-snug subpixel-antialiased text-base"
        >
          Not provided
        </p>
      </div>
    </div>
    <div style="width:90px;">
      <navigation-context
        v-if="
          isCentreDirector &&
            row.username.text.toLowerCase() !== profile.detuserid.toLowerCase()
        "
        class="float-right"
        :ariaLabel="`Actions for ${row.educatorsFullName.text}`"
        icon="ellipsis"
        icon-size="large"
        :actions="filteredActions"
        @click="handleRowAction($event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import handleRoles from "@/mixins/handleRoles";
import NavigationContext from "@/components/navigation/NavigationContext.vue";

export default {
  name: "DoeRow",
  mixins: [handleRoles],
  props: {
    actions: {
      type: Array,
      required: true
    },
    columns: {
      type: Array
    },
    row: {
      type: Object
    },
    isSelected: {
      type: Boolean,
      required: false
    },
    actionBoxes: {
      type: Boolean
    }
  },
  components: {
    NavigationContext
  },
  methods: {
    updateSelectedItems($event) {
      this.$store.commit('SET_BUTTON', this.row.id);
      this.$emit("input", $event);
    },
    handleRowAction($event) {
      this.$set($event, "id", this.row.id);
      this.$set($event, "role", this.userRole);
      this.$emit("row:action", $event);
    }
  },
  computed: {
    ...mapGetters(["getService"]),
    userRole() {
      return this.row.entitlements.entitlements[this.serviceData.seNumber]
    },
    formattedUserRole() {
      if(this.userRole.includes("Director")) {
        return "Administrator";
      }
      return "Educator";
    },
    serviceData() {
      return this.getService;
    },
    isChecked(){
      let flag=this.$root.selectedItems.includes(this.row.id);
      return flag;
    },
    filteredActions() {
      return this.actions.filter(action =>
        action.allowFor.includes(
          this.isCentreDirector
            ? "admin"
            : "user"
        )
      );
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  max-width: 120px;
}
@media (min-width: 768px) {
  p {
    max-width: 120px;
  }
}
</style>
